const o=.2,t=[.2,.8];export{t as INTERSECTION_RATIO_CLAMP,o as INTERSECTION_THRESHOLD};
//# sourceMappingURL=constants.js.map
